import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWorkspaceExtensionsConfigService = ( createDecorator('IWorkspaceExtensionsConfigService'));
export { IWorkspaceExtensionsConfigService };
